const NS = 'http://www.w3.org/2000/svg';

function svg(d, sw = 1.75) {
    return { d, sw };
}

const PATHS = {
    search: svg('<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>'),
    filter: svg('<path d="M2 4h20M4 8h16M6 12h12M8 16h8"/>', 2),
    layers: svg('<path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="m2 17 10 5 10-5"/><path d="m2 12 10 5 10-5"/>'),
    back: svg('<path d="M19 12H5M12 19l-7-7 7-7"/>', 2),
    close: svg('<path d="M18 6L6 18M6 6l12 12"/>', 2),
    loc: svg('<path d="M12 21s-6-5.5-6-10a6 6 0 1 1 12 0c0 4.5-6 10-6 10z"/><circle cx="12" cy="11" r="2"/>'),
    bookmark: svg('<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>'),
    plus: svg('<path d="M12 5v14M5 12h14"/>', 2),
    list: svg('<line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>', 2),
    user: svg('<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>'),
    dots: svg('<circle cx="12" cy="5" r="1.2"/><circle cx="12" cy="12" r="1.2"/><circle cx="12" cy="19" r="1.2"/>', 2),
    warn: svg('<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>'),
    ext: svg('<path d="M15 3h6v6M10 14L21 3M21 14v7H3V3h7"/>', 2),
    check: svg('<path d="M5 13l4 4L19 7"/>', 2.5),
    geoloc: svg('<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2"/>', 2),
    building: svg('<rect x="4" y="3" width="16" height="18" rx="1"/><path d="M9 7h.01M14 7h.01M9 11h.01M14 11h.01M10 21v-3h4v3"/>'),
    parcel: svg('<rect x="3" y="3" width="18" height="18" rx="1"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18" stroke-dasharray="2 2"/>'),
    tran: svg('<circle cx="12" cy="12" r="9"/><path d="M12 7v10M9 9.5h4a1.5 1.5 0 0 1 0 3h-2a1.5 1.5 0 0 0 0 3h4"/>'),
    signal: svg('<circle cx="12" cy="12" r="2"/><path d="M8.5 8.5a5 5 0 0 0 0 7M15.5 15.5a5 5 0 0 0 0-7M5 5a10 10 0 0 0 0 14M19 19a10 10 0 0 0 0-14"/>'),
    thumbUp: svg('<path d="M14 9V5a3 3 0 0 0-6 0v4H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a3 3 0 0 0 3-2.5l1-7A2 2 0 0 0 18 9z"/>'),
    thumbDn: svg('<path d="M10 15v4a3 3 0 0 0 6 0v-4h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H8a3 3 0 0 0-3 2.5l-1 7A2 2 0 0 0 6 15z"/>'),
    flag: svg('<path d="M4 21V4h13l-2 5 2 5H4"/>'),
    pin: svg('<path d="M12 21s-6-5.5-6-10a6 6 0 1 1 12 0c0 4.5-6 10-6 10z"/><circle cx="12" cy="11" r="2"/>', 2),
    chev: svg('<path d="M9 6l6 6-6 6"/>', 2),
    chevL: svg('<path d="M15 6l-6 6 6 6"/>', 2),
    chevD: svg('<path d="M6 9l6 6 6-6"/>', 2),
    chevU: svg('<path d="M6 15l6-6 6 6"/>', 2),
    trash: svg('<path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>'),
    edit: svg('<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>'),
    attach: svg('<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>'),
    ruler: svg('<path d="M16 2l6 6L8 22 2 16zM12 6l-2 2M14 8l-2 2M16 10l-2 2"/>'),
    zoom: svg('<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M8 11h6M11 8v6"/>'),
    eye: svg('<path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>'),
    road: svg('<path d="M4 22l3-20h10l3 20"/><path d="M12 6v3M12 12v3M12 18v3" stroke-dasharray="0"/>'),
    town: svg('<path d="M3 21h18"/><path d="M5 21V10l4-3 4 3v11"/><path d="M13 21V13l4-2 4 2v8"/><path d="M8 21v-4M16 21v-3"/>'),
    place: svg('<path d="M12 21s-7-6-7-12a7 7 0 0 1 14 0c0 6-7 12-7 12z"/><path d="M9 9h6M9 12h6"/>'),
};

export function iconMarkup(name, opts = {}) {
    const entry = PATHS[name];
    if (!entry) {
        return '';
    }
    const size = opts.size ?? 16;
    const stroke = opts.stroke ?? 'currentColor';
    const fill = opts.fill ?? 'none';
    const className = opts.class ? ` class="${opts.class}"` : '';
    return `<svg${className} width="${size}" height="${size}" viewBox="0 0 24 24" fill="${fill}" stroke="${stroke}" stroke-width="${entry.sw}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${entry.d}</svg>`;
}

export function iconElement(name, opts = {}) {
    const entry = PATHS[name];
    if (!entry) {
        return null;
    }
    const size = opts.size ?? 16;
    const stroke = opts.stroke ?? 'currentColor';
    const fill = opts.fill ?? 'none';
    const el = document.createElementNS(NS, 'svg');
    el.setAttribute('width', size);
    el.setAttribute('height', size);
    el.setAttribute('viewBox', '0 0 24 24');
    el.setAttribute('fill', fill);
    el.setAttribute('stroke', stroke);
    el.setAttribute('stroke-width', String(entry.sw));
    el.setAttribute('stroke-linecap', 'round');
    el.setAttribute('stroke-linejoin', 'round');
    el.setAttribute('aria-hidden', 'true');
    if (opts.class) {
        el.setAttribute('class', opts.class);
    }
    el.innerHTML = entry.d;
    return el;
}

export const ICON_NAMES = Object.keys(PATHS);
